module.exports = __webpack_public_path__ + "static/media/MetaMaskContract.bebd0987.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MetaMaskContract.png
// module id = 746
// module chunks = 1 3